var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalonSettingsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E1E3E3;}\n\t.st4{fill:#FFD1D1;}\n\t.st5{fill:none;}\n\t.st6{fill:#0A1514;}\n\t.st7{fill:#C0C3C3;}\n\t.st8{fill:#821bb8;}\n\t.st9{fill:#677371;}\n\t.st10{fill:none;stroke:#677371;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:#F8D1CF;}\n\t.st12{fill:#EE8B88;}\n\t.st13{display:inline;fill:#C0C3C3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -495,
    y: -332,
    className: "st2",
    width: 800,
    height: 3706
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "main"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29,10v17c0,2.2-1.8,4-4,4H7c-2.2,0-4-1.8-4-4V10"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27,1h-3c2.2,0,4,1.8,4,4v5.2c0,1.5-0.9,2.9-2.2,3.4c0.5,0.2,1,0.3,1.5,0.3c2.1,0,3.8-1.7,3.8-3.8V5 C31,2.8,29.2,1,27,1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26,14v13c0,2.2-1.8,4-4,4h3c2.2,0,4-1.8,4-4V14H26z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M27,0h-3.5H16H8.5H5C2.2,0,0,2.2,0,5v5.2c0,1.6,0.8,3,2,3.9V27c0,2.8,2.2,5,5,5h4h10h4c2.8,0,5-2.2,5-5V14.1 c1.2-0.9,2-2.3,2-3.9V5C32,2.2,29.8,0,27,0z M22.5,10.2c0,1.5-1.2,2.8-2.8,2.8S17,11.8,17,10.2V2h5.5V10.2z M15,10.2 c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8V2H15V10.2z M2,5c0-1.7,1.3-3,3-3h2.5v8.2c0,1.5-1.2,2.8-2.8,2.8S2,11.8,2,10.2V5z M12,30 v-7c0-2.2,1.8-4,4-4s4,1.8,4,4v1h-2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2v4H12z M28,27c0,1.7-1.3,3-3,3h-3v-7c0-3.3-2.7-6-6-6s-6,2.7-6,6 v7H7c-1.7,0-3-1.3-3-3V14.9C4.2,15,4.5,15,4.8,15c1.5,0,2.9-0.7,3.8-1.9c0.9,1.1,2.2,1.9,3.8,1.9s2.9-0.7,3.8-1.9 c0.9,1.1,2.2,1.9,3.8,1.9s2.9-0.7,3.8-1.9c0.9,1.1,2.2,1.9,3.8,1.9c0.3,0,0.5,0,0.8-0.1V27z M30,10.2c0,1.5-1.2,2.8-2.8,2.8 s-2.8-1.2-2.8-2.8V2H27c1.7,0,3,1.3,3,3V10.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "cm",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    width: 32,
    height: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonSettingsActive);
export default __webpack_public_path__ + "static/media/salon-settings-active.99ff18f436494cc054949e4f7d9120d7.svg";
export { ForwardRef as ReactComponent };